import { faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, CardBody } from 'reactstrap'
import { SkillLabel } from '../JobDetails/Details'
import { clientBaseUrl } from 'utils/AxiosInstance'

function ApplicationCard({
  application,
  selectedApplications,
  setSelectedApplications,
  stage,
  borderColor,
}) {
  const selected = selectedApplications?.includes(application?.id)

  let borderStyle = {}
  if (borderColor === 'green') {
    borderStyle = { border: '4px solid #28a745' }
  } else if (borderColor === 'orange') {
    borderStyle = { border: '4px solid #ffc107' }
  } else if (application.resume && !application.has_resume_text) {
    borderStyle = { border: '4px solid rgba(226, 81, 90, 0.6)' }
  } else {
    borderStyle = { border: 'none' }
  }

  return (
    <Card
      role='button'
      className='w-100'
      style={borderStyle}
      onClick={() => {
        if (!selected) {
          setSelectedApplications([...selectedApplications, application.id])
        } else {
          setSelectedApplications(
            selectedApplications.filter((el) => el !== application.id)
          )
        }
      }}
    >
      <CardBody
        className='d-flex flex-column'
        style={{ backgroundColor: selected && '#d1ecf1' }}
      >
        <div className='d-flex justify-content-between align-items-center'>
          <div className='d-flex align-items-center'>
            <div
              style={{
                width: '20px',
                height: '20px',
                border: '2px solid #0dcaf0',
                borderRadius: '50%',
                position: 'relative',
                display: 'inline-block',
              }}
              className='mr-2'
            >
              {selected && (
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    backgroundColor: '#0dcaf0',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                />
              )}
            </div>

            <span className='title mr-3'>{application.name}</span>
            <SkillLabel skill={stage?.name} />
            {application?.archived ? (
              <SkillLabel skill={'Archived'} background='bg-danger' />
            ) : null}

            {application?.reviewed ? (
              <SkillLabel skill={'AI Reviewed'} background='bg-success' />
            ) : null}

            {application?.reviewed ? (
              <SkillLabel
                skill={`Score: ${application?.score}`}
                background='bg-warning'
              />
            ) : null}
          </div>
          <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
            {application.resume && (
              <button
                className='btn btn-outline-info py-1'
                onClick={(e) => {
                  e.stopPropagation()
                  window.open(application?.resume, '_blank')
                }}
              >
                Open CV
              </button>
            )}
            <FontAwesomeIcon
              icon={faEye}
              size='xl'
              role='button'
              title='View Application Details'
              className='text-warning'
              onClick={(e) => {
                e.stopPropagation()
                window.open(
                  `/job/application/details?application=${application.id}`,
                  '_blank'
                )
              }}
            />
          </div>
        </div>
        {application?.reason && application?.reviewed ? (
          <div className='bg-secondary rounded mt-3 p-2'>
            <span className='font-weight-bold'>Description:</span>{' '}
            {application?.reason}
          </div>
        ) : null}
      </CardBody>
    </Card>
  )
}

export default ApplicationCard
